const WEBSOCKET_ROOT_URL = process.env.REACT_APP_WEBSOCKET_URL;

export const subscribeToTab = (tabUUID, onUpdatesReceived) => {
  if (!tabUUID) {
    throw new Error("subscribeToTab: Missing tab id")
  }
  const queryParams = new URLSearchParams();
  queryParams.append("tab_uuid", tabUUID);
  const tabSocket = new WebSocket(`${WEBSOCKET_ROOT_URL}/tab/?${queryParams.toString()}`)
  tabSocket.onmessage = (event) => {
    console.log("New SingleTab message received", event.data)
    onUpdatesReceived(JSON.parse(event.data))
  }
  return () => tabSocket.close();
};
